import { ReactElement } from "react";
import { ActivityMenuItem } from "../ActivityMenu/ActivityMenuItem";
import { NewFeaturesMenuItem } from "../NewFeaturesMenuItem";
import { setTrackingId } from "client/Misc/utils";
import styles from "./MainMenu.module.less";
import { WorkspaceHeaderStyle } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import { EffectiveTheme, useEffectiveTheme } from "client/Hooks";
import { Theme } from "client/Api/Branding/UserTheme/userTheme";

export type MainMenuProps = {
	headerStyle: WorkspaceHeaderStyle;
};

export const MainMenu = (props: MainMenuProps): ReactElement => {
	const {
		headerStyle
	} = props;

	const effectiveTheme: EffectiveTheme = useEffectiveTheme();

	const effectiveHeaderStyle: WorkspaceHeaderStyle = effectiveTheme === Theme.Dark
		? WorkspaceHeaderStyle.WhiteBackground
		: headerStyle;

	return (
		<div className={styles.root}>
			<ul
				{...setTrackingId("header-main-menu")}
				className={styles.list}
			>
				<ActivityMenuItem headerStyle={effectiveHeaderStyle} />
				<NewFeaturesMenuItem headerStyle={effectiveHeaderStyle} />
			</ul>
		</div>
	);
};
MainMenu.displayName = "MainMenu";
